<template>
  <page-section :title="$t('ProfileMergeHistory_Title')">
    <rest-list :payload="fetchEndpoint">
      <rest-list-column
        prop="id"
        :title="$t('ProfileMergeHistory_Field_ID')"
        :sortable="false"
        :width="150"
      />

      <rest-list-column-enum
        prop="role"
        :title="$t('ProfileMergeHistory_Field_Role')"
        :enum="MergeHistoryRole"
        :sortable="false"
        :filterable="false"
        :filter-input="false"
        :width="100"
      />

      <rest-list-column
        prop="profiles"
        :title="$t('ProfileMergeHistory_Field_Profiles')"
        :sortable="false"
        :filterable="false"
        :filter-input="false"
      />

      <rest-list-column-enum
        prop="strategy"
        :title="$t('ProfileMergeHistory_Field_Strategy')"
        :enum="MergeHistoryStrategy"
        :sortable="false"
        :filterable="false"
        :filter-input="false"
        :width="150"
      />

      <rest-list-column
        prop="processors"
        :title="$t('ProfileMergeHistory_Field_Processors')"
        :sortable="false"
        :filterable="false"
        :filter-input="false"
      />

      <rest-list-column-boolean
        prop="deactivate_sources"
        :title="$t('ProfileMergeHistory_Field_DeactivateSources')"
        :sortable="false"
        :filterable="false"
        :filter-input="false"
      />

      <rest-list-column-date
        prop="executed_at"
        :title="$t('ProfileMergeHistory_Field_Executed_At')"
        :width="200"
        :sortable="false"
        :filterable="false"
        :filter-input="false"
      />

      <rest-list-column
        prop="task"
        :title="$t('ProfileMergeHistory_Field_Task')"
        :filterable="false"
        :sortable="false"
        :filter-input="false"
        :width="70"
      >
        <template slot-scope="scope">
          <router-link
            v-if="Number.isInteger(scope.row.task) && scope.row.task !== 0"
            :to="rowViewTask(scope.row)"
            target="_blank"
          >
            {{ $t('ProfileMergeHistory_Task_Link') }}
          </router-link>
          <div v-else>
            {{ scope.row.executed_at ? $t('ProfileMergeHistory_Manual') : '-' }}
          </div>
        </template>
      </rest-list-column>
    </rest-list>
  </page-section>
</template>

<script>
import PageSection from '@/common/components/page/PageSection'
import RestList from '@/common/components/rest/RestList'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumn from '@/common/components/rest/RestListColumn'
import {
  MergeHistoryRole,
  MergeHistoryStrategy
} from '@/modules/profiles/enum/MergeHistory'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import RestListColumnBoolean from '@/common/components/rest/RestListColumnBoolean'

export default {
  name: 'ProfileMergeHistory',

  components: {
    RestListColumnBoolean,
    RestListColumnDate,
    RestListColumn,
    RestListColumnEnum,
    RestList,
    PageSection
  },

  data() {
    return {
      MergeHistoryRole,
      MergeHistoryStrategy
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `profiles/${this.$route.query.profile_id}/merge`
      })
    }
  },

  methods: {
    rowViewTask(row) {
      return projectRoute({
        name: 'TaskHistoryView',
        query: { id: row.task }
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/profiles/pages/ProfileMergeHistory.vue